import * as englishTranslations from '@analyzer/i18n/en/index.ts'
import { SupportedLanguages } from '@core/types/i18n'
import { createI18nConfig } from '@core/utils/language/createI18nConfig'
import {
  applyDateFnsLocale,
  followI18nDateFnsLocale,
} from '@core/utils/language/date-fns-locale'
import { isSupportedLanguage } from '@core/utils/language/is-supported-language'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'

followI18nDateFnsLocale(i18n)

export const i18nInit = i18n
  .use(LanguageDetector)
  .use(
    resourcesToBackend((lang: string) => {
      let lng = lang.split('-')[0]
      if (!isSupportedLanguage(lng)) lng = SupportedLanguages.English

      const i18nTranslations =
        lng === SupportedLanguages.English
          ? englishTranslations
          : import(`./${lng}/index.ts`)

      // date-fns follows i18n: applied before languageChanged fires.
      return Promise.all([i18nTranslations, applyDateFnsLocale(lng)]).then(
        ([trans]) => trans
      )
    })
  )
  .use(initReactI18next)
  .init(createI18nConfig())

export default i18n
